import { QueryParams } from '@/types/query';

const convertValuesToString = (params: QueryParams): Record<string, string> => {
  return Object.entries(params).reduce(
    (acc, [key, value]) => {
      acc[key] = value.toString();
      return acc;
    },
    {} as Record<string, string>
  );
};

/**
 * Converts a query params object into query string
 * @param params - query params object
 * @returns string - query string
 */
export const toQueryString = (params: QueryParams): string => {
  return `?${new URLSearchParams(convertValuesToString(params)).toString()}`;
};
